module.exports = __webpack_public_path__ + "static/media/funnel_woman.9d4c5668.jpg";